// extracted by mini-css-extract-plugin
export default {"mainCard":"forgot_mainCard__5HgqW","input":"forgot_input__RuAsq","crossIcon":"forgot_crossIcon__UV8gk","ctaBtn":"forgot_ctaBtn__fLfsC"};